import { v4 as uuidv4 } from 'uuid';
import Ecom from '../images/Ecom.jpg';
import VideoLib from '../images/VideoLib.jpg';
import SocialMedia from '../images/SocialMedia.jpg';
import QuizApp from '../images/QuizApp.jpg';
import ComponentLib from '../images/ComponentLib.PNG';

const projects = [
  {
    id: uuidv4(),
    name: 'ECommerce App',
    desc:
      'An E-commerce App using MERN stack with cart, wishlist, order and addresses functionality. Login/Signup Available',
    img: Ecom,
    projectlink: 'https://ad-astra-shop.netlify.app/'
  },
  {
    id: uuidv4(),
    name: 'Social Media',
    desc:
      'A Social Media using React, Redux and MongoDB as backend. Users Login/Sigup, Create Posts, Like, User Profile, Followers/Followers',
    img: SocialMedia,
    projectlink: 'https://ad-astra-connect.netlify.app/'
  },
  {
    id: uuidv4(),
    name: 'Quiz App',
    desc:
      'Quiz App built using React, TypeScript and Open TDB API for questions. You can play variety of quizzes of different category.',
    img: QuizApp,
    projectlink: 'https://ad-astra-quiz.netlify.app/'
  },
  {
    id: uuidv4(),
    name: "Video Library",
    desc:
      'Video Playing Library built using MERN stack with Youtube like features such as playlist, watch later and login/signup',
    img: VideoLib,
    projectlink: 'https://ad-astra-camp.netlify.app/'
  },
  {
    id: uuidv4(),
    name: 'CSS Component Library',
    desc:
      'A CSS library built using HTML and CSS that can be used to style html components or make outlines as in bootstrap.',
    img: ComponentLib,
    projectlink: 'https://vajra-ui.netlify.app/'
  },
];

export default projects;